// Amount of customer's active orders on orders-history page
export const MAX_ACTIVE_ORDERS = 10

export const DEFAULT_ORDER_TABLE_SIZE = 5

export const MAX_ORDERS_REQ_LIMIT = 20

export const ORDER_STATUS = {
  CREATED: 'created',
  NEW: 'new',
  OPEN: 'open',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  REPLACED: 'replaced',
  FAILED: 'failed',
  FINDING_A_RIDER: 'FINDING_A_RIDER',
  RIDER_ASSIGNED: 'RIDER_ASSIGNED',
} as const

export const ORDER_UI_STATUS = {
  PREPARING_FOR_DISPATCH: 'Preparing for Dispatch',
  COMPLETED: 'Completed',
  PROCESSED: 'Order processed',
  PICKED: 'Order picked',
  PLACED: 'Order placed',
  CANCELLED: 'Cancelled',
  REFUNDED: 'Refunded',
  PARTIALLY_REFUNDED: 'Partially Refunded',
  OUT_FOR_DELIVERY: 'Out for Delivery',
  DELIVERED: 'Delivered',
  DELIVERY_UNSUCCESSFUL: 'Delivery Unsuccessful',
  ORDERED: 'Ordered',
  UNAVAILABLE: 'Unavailable',
  SUBSTITUTED: 'Substituted',
  FINDING_A_RIDER: 'Finding a Rider',
  RIDER_ASSIGNED: 'Rider Assigned',
} as const

export const ORDER_REFUND_STATUS = {
  NOT_REFUNDED: 0,
  REFUNDED: 1,
  PARTIAL_REFUND: 2,
} as const

export const ORDER_DELIVERY_STATUS = {
  PLACED: 'ORDER_PLACED',
  PICKED: 'ORDER_PICKED',
  FINDING_A_RIDER: 'FINDING_A_RIDER',
  RIDER_ASSIGNED: 'RIDER_ASSIGNED',
  RIDER_REASSIGNING: 'RIDER_REASSIGNING',
  PACKAGE_RETURNING: 'PACKAGE_RETURNING',
  PACKAGE_RETURNED: 'PACKAGE_RETURNED',
  PACKAGE_SPLIT: 'PACKAGE_SPLIT',
  OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
} as const

export const DELIVERY_PARTNER_STATUS: Record<number, string> = {
  11: ORDER_DELIVERY_STATUS.RIDER_ASSIGNED,
  2: ORDER_DELIVERY_STATUS.OUT_FOR_DELIVERY,
  5: ORDER_DELIVERY_STATUS.COMPLETED,
  6: ORDER_DELIVERY_STATUS.CANCELLED,
  12: ORDER_DELIVERY_STATUS.RIDER_REASSIGNING,
  13: ORDER_DELIVERY_STATUS.PACKAGE_RETURNING,
  14: ORDER_DELIVERY_STATUS.PACKAGE_RETURNED,
  15: ORDER_DELIVERY_STATUS.PACKAGE_SPLIT,
} as const

export const PAYMENT_SUMMARY_TYPES = {
  PREBOOK_DELIVERY: 'Pre-book Delivery',
  TOTAL: 'Total',
  SUBTOTAL: 'Subtotal',
  PROMOTIONAL_DISCOUNT: 'Promotional Discount',
  BASKET_TOTAL: 'Basket Total',
  DELIVERY: 'Delivery',
  RAPID_DELIVERY: 'Rapid Delivery',
  SMALL_BASKET_FEE: 'Small Basket Fee'
} as const

